import React, {Component} from 'react';

class PropertyListing extends Component {
    render() {
        return (
            <div>
              <h1>add property</h1>
            </div>
        );
    }
}

export default PropertyListing;